import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import FlashLib from 'flashlib_onlyplay';
import animationTypes from '../enums/eAnimationTypes';
import eSymbolIndex from './eSymbolIndex';
import { eFireAnimationNames } from '../enums/eAnimationNames';
import SequenceAnimation from 'Engine/animations/sequenceAnimation';
import eEventTypes from '../enums/eEventTypes';

const firstFramesData = {};

export default class SymbolAnimation extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.animationNames = {
      [eSymbolIndex.ESI_WILD]: 'wild',
      [eSymbolIndex.ESI_ORANGE]: 'orange',
      [eSymbolIndex.ESI_WATERMELON]: 'watermelon',
      [eSymbolIndex.ESI_LEMON]: 'lemon',
      [eSymbolIndex.ESI_PLUM]: 'plum',
      [eSymbolIndex.ESI_CHERRY]: 'cherry',
      [eSymbolIndex.ESI_GRAPE]: 'grape',
      [eSymbolIndex.ESI_SCATTER]: 'scatter',
    };

    this.onComplete = () => {};
    this.onStart = () => {};

    this.animation = null;
    this.init();
    this.addListeners();
  }

  init() {
    this.animation = new SequenceAnimation(animationTypes.SYMBOLS);
    this.fireAnimation = new SequenceAnimation(animationTypes.SYMBOL_FIRE);
    this.fireAnimation.visible = false;
    this.addChildAt(this.fireAnimation, 0);
    this.animation.visible = false;
    this.animation.onCompleteAnimation.add(this._complete.bind(this));
    this.addChild(this.animation);
  }

  addListeners() {
    GlobalDispatcher.add('stateStart:jackpotGameInState', () => this.isActive = this.animation.visible, this);
    GlobalDispatcher.add('stateStart:jackpotGameOutState', () => this.animation.visible = this.isActive, this);
    GlobalDispatcher.add(eEventTypes.EBET_BIG_WIN_ANIMATION_VISIBLE_CHANGE, this.setAutoUpdate, this);
  }

  setAutoUpdate({ params: visible }) {
    this.animation.autoUpdate = !visible;
    this.fireAnimation.autoUpdate = !visible;
  }

  start(loop) {
    this.animation.visible = true;
    this.animation.setAnimation(this._getAnimationName(this.id, this.type), loop);
  }

  stop() {
    if (this.animation) {
      this.animation.visible = false
    }
  }

  startFire() {
      this.fireAnimation.visible = true;
      this.fireAnimation.setAnimation(`${eFireAnimationNames.START}_${this.type - 2}`, false);
      this.fireAnimation.addAnimation(`${eFireAnimationNames.IDLE}_${this.type - 2}`, true, 0);
  }

  stopFire() {
      this.fireAnimation.visible = false;
  }

  _getAnimationName(id, type) {
    return `${this.animationNames[id]}_${type - 2}`
  }

  getFirstFrameData(id, type) {
    const animationName = this._getAnimationName(id, type)
    let firstFrameData = firstFramesData[this.animation._animationType] && firstFramesData[this.animation._animationType][animationName];
    if (!firstFrameData) {
      if (!firstFramesData[this.animation._animationType]) {
        firstFramesData[this.animation._animationType] = {};
      }
      firstFrameData = this.animation._createTexture(this.animation._animationType, animationName, 0);
      firstFramesData[this.animation._animationType][animationName] = firstFrameData
    }
    return firstFrameData;
  }

  _complete() {
    this.onComplete();
  }
}
